import { InputHTMLAttributes } from 'react';

interface Props extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type' | 'inputMode'> {
  id: string;
}

export function BigNumberInput({ id, className = '', ...rest }: Props) {
  return (
    <input
      id={id}
      type="number"
      inputMode="numeric"
      className={`w-full px-4 py-5 rounded-xl border border-[var(--line-strong,rgba(15,30,51,0.16))] bg-white text-3xl font-bold text-center text-[var(--brand-navy,#0A1128)] focus:outline-2 focus:outline-[var(--brand-primary,#22D3EE)] focus:border-transparent focus-visible:outline-2 focus-visible:outline-[var(--brand-primary,#22D3EE)] ${className}`}
      style={{ fontFamily: 'var(--brand-font-display)' }}
      {...rest}
    />
  );
}
